import { StudentAssessmentBlockOrUnblockType, StudentAssessmentType } from "../../../types/Assessment";
import { post, put } from "../../../utils/axios-config";
import { STUDENT_ASSESSMENTS, STUDENT_ASSESSMENTS_BLOCK_OR_UNBLOCK } from "../../../utils/constants";

export const updateStudentAssessment = async (data: StudentAssessmentType) => await put<StudentAssessmentType, string>(STUDENT_ASSESSMENTS, data);
export const updateStudentAssessment_blockOrUnblock = async (data: StudentAssessmentBlockOrUnblockType) => await put<StudentAssessmentBlockOrUnblockType, string>(STUDENT_ASSESSMENTS_BLOCK_OR_UNBLOCK, data);
